import styled from 'styled-components';

const TooltipBubble = styled.div`
  min-width: 120px;
  max-width: 210px;
  position: absolute;
  z-index: 10;

  &:after {
    content: '';
    position: absolute;
  }
`;

export default TooltipBubble;
